import {csiHost, executeAuthenticate, executeGetModuleDescription } from './executer'

//Соединение с платформой Simbix
export const SimbixConnectActions = {
    CONNECT_STARTED: () => ({
        type: SimbixConnectActions.CONNECT_STARTED,
    }),
    CONNECT_OK: simbix => ({
        type: SimbixConnectActions.CONNECT_OK,
        simbix,
    }),
    CONNECT_ERROR: () => ({
        type: SimbixConnectActions.CONNECT_ERROR,
    }),

    authenticate: currentUser => dispatch => {
            dispatch(SimbixConnectActions.CONNECT_STARTED());
            //		return executeAuthenticateByAccessToken(currentUser)
            return executeAuthenticate()
                .then(response => { 
                    console.log("authenticate", response);
                    dispatch(SimbixConnectActions.CONNECT_OK(response.simbix));
                    return response;
                })
                .catch(e => { 
                    console.error(new Error("cannot connect to simbix",e)); 
                    dispatch(SimbixConnectActions.CONNECT_ERROR());
                    //return Promise.resolve();
                    return Promise.reject(e);
                });
    },
};
